export const CONFIGURATION_VIEW_ACCESS_KEY =
  "dac690d1-6712-4aa6-9b4f-7d71bc4f8eb1";

// Company Profile

export const COMPANY_PROFILE_VIEW_ACCESS_KEY =
  "f78e6312-92f6-434d-aa7d-8bfb168fb12e";

export const UPDATE_COMPANY_PROFILE_ACCESS_KEY =
  "83b54d4e-dcf5-42ff-8d88-d7a3df38b4c4";

// Department

export const DEPARTMENT_VIEW_ACCESS_KEY =
  "da36512d-78a4-44b3-977e-0c5f39979ac6";

export const CREATE_DEPARTMENT_ACCESS_KEY =
  "9b6c1940-9007-4cf0-9d3b-ecb9d7e3dab0";

export const EDIT_DEPARTMENT_ACCESS_KEY =
  "b2643df5-07f1-4b10-bc02-c8b130e3c34b";

// Branch

export const BRANCH_VIEW_ACCESS_KEY = "d7b7a1d5-d267-4640-9eb6-b82dc5a84f16";

export const CREATE_BRANCH_ACCESS_KEY = "be79d1b3-3cc4-4a6d-b3c3-64e5a9d1c645";

export const EDIT_BRANCH_ACCESS_KEY = "a78aa075-88e0-4c52-a503-b8de29ff45b2";

// Custom Field

export const CUSTOM_FIELD_VIEW_ACCESS_KEY =
  "9057d872-1f18-42c8-b2fb-89b29f2c05cf";

export const CREATE_CUSTOM_FIELD_ACCESS_KEY =
  "5bb4b5d2-1913-4fd0-bcb0-fc0d95035f02";

export const EDIT_CUSTOM_FIELD_ACCESS_KEY =
  "ac083d58-1cf4-4568-84f3-76f5506e8df3";

// Employee

export const EMPLOYEE_VIEW_ACCESS_KEY =
  "a196c41a-5ecb-40c2-ace9-02b5f4819b29";

export const CREATE_EMPLOYEE_ACCESS_KEY =
  "26c44a29-9b81-45cf-84ab-6d9f22a0b8a7";

export const EDIT_EMPLOYEE_ACCESS_KEY = "723820ec-1fb9-472e-a64a-f526146c9b40";

export const VIEW_TEAM_EMPLOYEE_ACCESS_KEY =
  "d08e5377-09a6-42a5-8164-eb2af451bce3";

export const VIEW_HIERARCHY_EMPLOYEE_ACCESS_KEY =
  "17db6d86-bd6a-4150-bf40-5600a67a49f1";

// Attendance

// Team

export const VIEW_TEAM_ATTENDANCE_ACCESS_KEY =
  "8d33a155-2d7e-4a5d-8608-35431a44662c";

export const EDIT_TEAM_ATTENDANCE_ACCESS_KEY =
  "cc87c7e2-7a80-4d7f-b083-971bd25c9f6d";

export const VIEW_TEAM_ATTENDANCE_APPROVAL_ACCESS_KEY =
  "5ac47d4f-3063-4730-a9da-c4f403ca7853";

export const APPROVE_REJECT_TEAM_ATTENDANCE_ACCESS_KEY =
  "80c29697-0343-4c71-8556-0df10652b3f7";

export const VIEW_TEAM_LEAVE_APPROVAL_ACCESS_KEY =
  "1b5d106f-f3e8-41f3-8041-d3f71a19d27d";

export const APPROVE_REJECT_TEAM_LEAVE_ACCESS_KEY =
  "d6bbf8dd-ccd3-4866-9c57-afdc1cc9268a";

// All

export const VIEW_HIERARCHY_ATTENDANCE_ACCESS_KEY =
  "2ebd3c5d-dca8-45cc-8334-5a32f2451893";

export const EDIT_HIERARCHY_ATTENDANCE_ACCESS_KEY =
  "6aa0e447-7a32-4664-a53b-ae8c729d05af";

export const VIEW_HIERARCHY_ATTENDANCE_APPROVAL_ACCESS_KEY =
  "034d87cc-a1dd-42b0-9c20-f1163d4a5716";

export const APPROVE_REJECT_HIERARCHY_ATTENDANCE_ACCESS_KEY =
  "99cb748f-2de4-4fe7-9b47-77b9d929f5f1";

export const VIEW_HIERARCHY_LEAVE_APPROVAL_ACCESS_KEY =
  "08cd201a-d20d-45d3-8b60-3a6fb7e4acc0";

export const APPROVE_REJECT_HIERARCHY_LEAVE_ACCESS_KEY =
  "15c51336-a05b-488b-af43-29061deec942";

export const VIEW_ALL_LEAVE_APPROVAL_ACCESS_KEY =
  "c3d4e5f6-7a8b-4c1d-9a2f-0e1f2a3b4c5d";

export const VIEW_ALL_ATTENDANCE_APPROVAL_ACCESS_KEY =
   "e5b8f9c2-7a6d-4c1b-9a2f-3c4d5e6f7a8b";

// Report

export const CAN_VIEW_REPORT_ACCESS_KEY =
  "c77528b2-5d9f-49ad-b6d1-5f95e61a66a0";
export const CAN_VIEW_TEAM_REPORT_ACCESS_KEY =
  "5cd1e062-cf44-4b45-8f9b-784f82b15dc5";
export const CAN_VIEW_HIERARCHY_REPORT_ACCESS_KEY =
  "7152dbf3-263f-4d7e-9c28-3f147fc0357a";

//Client Key

export const CLIENT_VIEW_ACCESS_KEY = "f48a12c7-8f95-4a64-93de-0f1a52d96e21";
export const CREATE_CLIENT_ACCESS_KEY = "2de6f781-6a3d-46d2-a2e7-4e9c0e5f7b93";
export const EDIT_CLIENT_ACCESS_KEY = "c31b8a9f-54d2-4a9d-b0f4-8d76e3c912ab";

// Projects

export const PROJECT_VIEW_ACCESS_KEY = "7d2c9f41-3e8b-4f72-9c5a-1b64e8d3f2a7"
export const CREATE_PROJECT_ACCESS_KEY = "b81f6d2a-5c94-4a73-a9e1-6f3d2c7b8e45"
export const EDIT_PROJECT_ACCESS_KEY = "4e9a1c76-8d35-42bf-b7c2-9f1e5d3a6b84"


// Task

export const CREATE_TASK_ACCESS_KEY = "1c7d9e54-6b2f-4a81-b3e7-9d5f2a6c8b14"
export const EDIT_TASK_ACCESS_KEY = "7a3f1c92-5d8e-4b67-a9c1-2e6d4f8b3c75"
export const TASK_VIEW_ACCESS_KEY = "1ad2ad2f-31e1-470f-b954-51abcadde5d9"

// Task Settings

export const TASK_SETTINGS_VIEW_ACCESS_KEY = "c4a9d2e7-6f31-4b8c-9a52-1e7d3f6b8c24"
export const CREATE_TASK_SETTINGS_ACCESS_KEY = "8f2d7c41-5b9e-4d73-a6c1-3e9f2b7d5a18"
export const EDIT_TASK_SETTINGS_ACCESS_KEY = "2d7e5b91-8c34-4fa6-b1e9-6a3d7c2f5b84"

// Attendance Configuration
export const ATTENDANCE_CONFIGURATION_VIEW_ACCESS_KEY =
  "7f4b9c2d-8e31-4a6f-b5d2-1c8e7a3f9d24";

export const UPDATE_ATTENDANCE_CONFIGURATION_ACCESS_KEY =
  "3c8f1a7d-5e2b-4d9c-a6f1-8b3e7d2c5a25";

// Payroll
export const PAYROLL_VIEW_ACCESS_KEY =
  "9d7f6f2a-6d1e-4f4a-9b82-2b8f1f0c7e11";

export const CREATE_PAYROLL_ACCESS_KEY =
  "3a4d9f88-c0f5-4d8d-b6e7-7f5d9a3c2b12";

export const EDIT_PAYROLL_ACCESS_KEY =
  "b1e6c4d7-8f29-4e8b-a1c3-5d7f9b2e4a13";

// Roles
export const ROLES_VIEW_ACCESS_KEY =
  "f2a8d1c7-5b9e-4c6f-a2d1-8e3b7f4c5d14";

export const CREATE_ROLES_ACCESS_KEY =
  "7c3e9b2d-1f8a-4d5c-b7e9-2a6f8c1d3e15";

export const EDIT_ROLES_ACCESS_KEY =
  "4e7d2a9c-8b1f-4c3d-a5e7-9f2c6b1d8a16";

// Forms
export const FORMS_VIEW_ACCESS_KEY =
  "a8d3c7f1-2e9b-4d6a-b1f8-3c7e9d2a4b17";

export const CREATE_FORMS_ACCESS_KEY =
  "6f1b8d3c-7a2e-4c9d-b5f1-8d3a7c2e9b18";

export const EDIT_FORMS_ACCESS_KEY =
  "2c9e7a1d-4f8b-4d3c-a6e2-7b1f9d3c5a19";

// Location Group
export const LOCATION_GROUP_VIEW_ACCESS_KEY =
  "d7a2c9e4-1b8f-4c6d-a3e7-5f2b9d1c8a20";

export const CREATE_LOCATION_GROUP_ACCESS_KEY =
  "8b4d1f7c-2a9e-4d5c-b8f3-1e7a2c9d6b21";

export const EDIT_LOCATION_GROUP_ACCESS_KEY =
  "5e9c2a7d-8f1b-4c3d-a4e8-2d7b1f9c6a22";


export const default_roles_list = [
  {
    id: 1,
    name: "Organization",
    priority: 1,
    note: "",
    permission: [
      // {
      //   id: 101,
      //   role_uuid: CONFIGURATION_VIEW_ACCESS_KEY,
      //   dependency_for_uuid_list: [
      //     COMPANY_PROFILE_VIEW_ACCESS_KEY,
      //     UPDATE_COMPANY_PROFILE_ACCESS_KEY,
      //     DEPARTMENT_VIEW_ACCESS_KEY,
      //     CREATE_DEPARTMENT_ACCESS_KEY,
      //     EDIT_DEPARTMENT_ACCESS_KEY,
      //     BRANCH_VIEW_ACCESS_KEY,
      //     CREATE_BRANCH_ACCESS_KEY,
      //     EDIT_BRANCH_ACCESS_KEY,
      //     CUSTOM_FIELD_VIEW_ACCESS_KEY,
      //     CREATE_CUSTOM_FIELD_ACCESS_KEY,
      //     EDIT_CUSTOM_FIELD_ACCESS_KEY,
      //   ],
      //   notes: "User Can View Configuration",
      //   element: "per_configuration_view",
      //   dependency_to_element_list: [],
      //   checked: false,
      //   disabled: false,
      // },
      {
        id: 102,
        role_uuid: COMPANY_PROFILE_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [UPDATE_COMPANY_PROFILE_ACCESS_KEY],
        notes: "User Can View Company Profile",
        element: "per_company_profile_view",
        dependency_to_element_list: ["per_configuration_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 103,
        role_uuid: UPDATE_COMPANY_PROFILE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Company Profile",
        element: "per_company_profile_update",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_company_profile_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 104,
        role_uuid: DEPARTMENT_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_DEPARTMENT_ACCESS_KEY,
          EDIT_DEPARTMENT_ACCESS_KEY,
        ],
        notes: "User Can View Department",
        element: "per_department_view",
        dependency_to_element_list: ["per_configuration_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 105,
        role_uuid: CREATE_DEPARTMENT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Department",
        element: "per_department_create",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_department_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 106,
        role_uuid: EDIT_DEPARTMENT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Department",
        element: "per_department_update",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_department_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 107,
        role_uuid: BRANCH_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_BRANCH_ACCESS_KEY,
          EDIT_BRANCH_ACCESS_KEY,
        ],
        notes: "User Can View Branch",
        element: "per_branch_view",
        dependency_to_element_list: ["per_configuration_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 108,
        role_uuid: CREATE_BRANCH_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Branch",
        element: "per_branch_create",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_branch_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 109,
        role_uuid: EDIT_BRANCH_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Branch",
        element: "per_branch_update",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_branch_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 110,
        role_uuid: CUSTOM_FIELD_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_CUSTOM_FIELD_ACCESS_KEY,
          EDIT_CUSTOM_FIELD_ACCESS_KEY,
        ],
        notes: "User Can View Custom field",
        element: "per_custom_field_view",
        dependency_to_element_list: ["per_configuration_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 111,
        role_uuid: CREATE_CUSTOM_FIELD_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Custom field",
        element: "per_custom_field_create",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_custom_field_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 112,
        role_uuid: EDIT_CUSTOM_FIELD_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Custom field",
        element: "per_custom_field_update",
        dependency_to_element_list: [
          "per_configuration_view",
          "per_custom_field_view",
        ],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 2,
    name: "Employee",
    priority: 2,
    note: "",
    permission: [
      {
        id: 201,
        role_uuid: EMPLOYEE_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_EMPLOYEE_ACCESS_KEY,
          EDIT_EMPLOYEE_ACCESS_KEY,
          VIEW_TEAM_EMPLOYEE_ACCESS_KEY,
          VIEW_HIERARCHY_EMPLOYEE_ACCESS_KEY,
        ],
        notes: "User Can View Employee",
        element: "per_employee_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 202,
        role_uuid: CREATE_EMPLOYEE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Employee",
        element: "per_employee_create",
        dependency_to_element_list: ["per_employee_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 203,
        role_uuid: EDIT_EMPLOYEE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Employee",
        element: "per_employee_update",
        dependency_to_element_list: ["per_employee_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 204,
        role_uuid: VIEW_TEAM_EMPLOYEE_ACCESS_KEY,
        dependency_for_uuid_list: [VIEW_HIERARCHY_EMPLOYEE_ACCESS_KEY,],
        notes: "User Can View Team Employee",
        element: "per_team_employee_view",
        dependency_to_element_list: ["per_employee_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 205,
        role_uuid: VIEW_HIERARCHY_EMPLOYEE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View Hierarchy Employee",
        element: "per_hierarchy_employee_view",
        dependency_to_element_list: ["per_employee_view", "per_team_employee_view",],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 3,
    name: "Attendance",
    priority: 3,
    note: "",
    permission: [
      {
        id: 302,
        role_uuid: VIEW_TEAM_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [
          EDIT_TEAM_ATTENDANCE_ACCESS_KEY,
          APPROVE_REJECT_TEAM_ATTENDANCE_ACCESS_KEY,
        ],
        notes: "User Can View Team Attendance",
        element: "per_attendance_view_team",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 303,
        role_uuid: EDIT_TEAM_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Team Attendance",
        element: "per_attendance_edit_team",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_attendance_view_team",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 304,
        role_uuid: APPROVE_REJECT_TEAM_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Approve/Reject Team Attendance",
        element: "per_approve_reject_team",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_attendance_view_team",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 305,
        role_uuid: VIEW_HIERARCHY_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [
          EDIT_HIERARCHY_ATTENDANCE_ACCESS_KEY,
          APPROVE_REJECT_HIERARCHY_ATTENDANCE_ACCESS_KEY,
        ],
        notes: "User Can View Hierarchy Attendance",
        element: "per_attendance_view_hierarchy",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 306,
        role_uuid: EDIT_HIERARCHY_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Hierarchy Attendance",
        element: "per_attendance_edit_hierarchy",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_attendance_view_hierarchy",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 307,
        role_uuid: APPROVE_REJECT_HIERARCHY_ATTENDANCE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Approve/Reject Hierarchy Attendance",
        element: "per_approve_reject_hierarchy",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_attendance_view_hierarchy",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 308,
        role_uuid: VIEW_TEAM_LEAVE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [APPROVE_REJECT_TEAM_LEAVE_ACCESS_KEY],
        notes: "User Can View Team's Leave Approval",
        element: "per_teams_leave_approval_view",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 309,
        role_uuid: APPROVE_REJECT_TEAM_LEAVE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Approve/Reject Team's Leave",
        element: "per_approve_reject_teams_leave",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_teams_leave_approval_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 310,
        role_uuid: VIEW_HIERARCHY_LEAVE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [APPROVE_REJECT_HIERARCHY_LEAVE_ACCESS_KEY],
        notes: "User Can View Hierarchy Leave Approval",
        element: "per_hierarchy_leave_approval_view",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 311,
        role_uuid: APPROVE_REJECT_HIERARCHY_LEAVE_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Approve/Reject Hierarchy Leave",
        element: "per_approve_reject_hierarchy_leave",
        dependency_to_element_list: [
          "per_attendance_view",
          "per_hierarchy_leave_approval_view",
        ],
        checked: false,
        disabled: false,
      },
      {
        id: 312,
        role_uuid: VIEW_TEAM_ATTENDANCE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View Team's Attendance Approval",
        element: "per_team_attendance_approval_view",
        dependency_to_element_list: ["per_attendance_view", "per_attendance_view_team"],
        checked: false,
        disabled: false,
      },
      {
        id: 313,
        role_uuid: VIEW_HIERARCHY_ATTENDANCE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View Hierarchy Attendance Approval",
        element: "per_hierarchy_attendance_approval_view",
        dependency_to_element_list: ["per_attendance_view", "per_attendance_view_hierarchy"],
        checked: false,
        disabled: false,
      },

      {
        id: 314,
        role_uuid: VIEW_ALL_LEAVE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View All Leave Approval",
        element: "per_all_leave_approval_view",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },

      {
        id: 315,
        role_uuid: VIEW_ALL_ATTENDANCE_APPROVAL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View All Attendance Approval",
        element: "per_all_attendance_approval_view",
        dependency_to_element_list: ["per_attendance_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 4,
    name: "Report",
    priority: 4,
    note: "",
    permission: [
      {
        id: 401,
        role_uuid: CAN_VIEW_REPORT_ACCESS_KEY,
        dependency_for_uuid_list: [
          CAN_VIEW_TEAM_REPORT_ACCESS_KEY,
          CAN_VIEW_HIERARCHY_REPORT_ACCESS_KEY,
        ],
        notes: "User Can View Report",
        element: "per_report_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 402,
        role_uuid: CAN_VIEW_TEAM_REPORT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View Team Report",
        element: "per_team_report_view",
        dependency_to_element_list: ["per_report_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 403,
        role_uuid: CAN_VIEW_HIERARCHY_REPORT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can View Hierarchy Report",
        element: "per_hierarchy_report_view",
        dependency_to_element_list: ["per_report_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 5,
    name: "Clients",
    priority: 5,
    note: "",
    permission: [
      {
        id: 501,
        role_uuid: CLIENT_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_CLIENT_ACCESS_KEY,
          EDIT_CLIENT_ACCESS_KEY,
        ],
        notes: "User Can View Clients",
        element: "per_client_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 502,
        role_uuid: CREATE_CLIENT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Clients",
        element: "per_create_client",
        dependency_to_element_list: ["per_client_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 503,
        role_uuid: EDIT_CLIENT_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Clients",
        element: "per_edit_client",
        dependency_to_element_list: ["per_client_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
        "id": 6,
        "name": "Projects",
        "priority": 6,
        "note": "",
        "permission": [
            {
                "id": 601,
                "role_uuid": PROJECT_VIEW_ACCESS_KEY,
                "dependency_for_uuid_list": [CREATE_PROJECT_ACCESS_KEY, EDIT_PROJECT_ACCESS_KEY],
                "notes": "User Can View Projects",
                "element": "per_project_view",
                "dependency_to_element_list": [],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 602,
                "role_uuid": CREATE_PROJECT_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Create Projects",
                "element": "per_create_project",
                "dependency_to_element_list": ["per_project_view"],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 603,
                "role_uuid": EDIT_PROJECT_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Edit Projects",
                "element": "per_edit_project",
                "dependency_to_element_list": ["per_project_view"],
                "checked": false,
                "disabled": false,
            },
        ],
    },
    {
        "id": 7,
        "name": "Task",
        "priority": 7,
        "note": "",
        "permission": [
            {
                "id": 701,
                "role_uuid": CREATE_TASK_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Create Task",
                "element": "per_create_task",
                "dependency_to_element_list": ["per_task_view"],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 702,
                "role_uuid": EDIT_TASK_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Edit Task",
                "element": "per_edit_task",
                "dependency_to_element_list": ["per_task_view"],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 703,
                "role_uuid": TASK_SETTINGS_VIEW_ACCESS_KEY,
                "dependency_for_uuid_list": [CREATE_TASK_SETTINGS_ACCESS_KEY, EDIT_TASK_SETTINGS_ACCESS_KEY],
                "notes": "User Can View Task Status",
                "element": "per_task_status_view",
                "dependency_to_element_list": [],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 704,
                "role_uuid": CREATE_TASK_SETTINGS_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Create Task Status",
                "element": "per_create_task_status",
                "dependency_to_element_list": ["per_task_status_view"],
                "checked": false,
                "disabled": false,
            },
            {
                "id": 705,
                "role_uuid": EDIT_TASK_SETTINGS_ACCESS_KEY,
                "dependency_for_uuid_list": [],
                "notes": "User Can Edit Task Status",
                "element": "per_edit_task_status",
                "dependency_to_element_list": ["per_task_status_view"],
                "checked": false,
                "disabled": false,
            },

            {
                "id": 706,
                "role_uuid": TASK_VIEW_ACCESS_KEY,
                "dependency_for_uuid_list": [CREATE_TASK_ACCESS_KEY, EDIT_TASK_ACCESS_KEY],
                "notes": "User Can View Task",
                "element": "per_task_view",
                "dependency_to_element_list": [],
                "checked": false,
                "disabled": false,
            },
        ],
    },
  {
    id: 8,
    name: "Payroll",
    priority: 8,
    note: "",
    permission: [
      {
        id: 801,
        role_uuid: PAYROLL_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_PAYROLL_ACCESS_KEY,
          EDIT_PAYROLL_ACCESS_KEY,
        ],
        notes: "User Can View Payroll",
        element: "per_payroll_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 802,
        role_uuid: CREATE_PAYROLL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Payroll",
        element: "per_payroll_create",
        dependency_to_element_list: ["per_payroll_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 803,
        role_uuid: EDIT_PAYROLL_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Payroll",
        element: "per_payroll_update",
        dependency_to_element_list: ["per_payroll_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 9,
    name: "Roles",
    priority: 9,
    note: "",
    permission: [
      {
        id: 901,
        role_uuid: ROLES_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_ROLES_ACCESS_KEY,
          EDIT_ROLES_ACCESS_KEY,
        ],
        notes: "User Can View Roles",
        element: "per_roles_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 902,
        role_uuid: CREATE_ROLES_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Roles",
        element: "per_roles_create",
        dependency_to_element_list: ["per_roles_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 903,
        role_uuid: EDIT_ROLES_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Roles",
        element: "per_roles_update",
        dependency_to_element_list: ["per_roles_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 10,
    name: "Forms",
    priority: 10,
    note: "",
    permission: [
      {
        id: 1001,
        role_uuid: FORMS_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_FORMS_ACCESS_KEY,
          EDIT_FORMS_ACCESS_KEY,
        ],
        notes: "User Can View Forms",
        element: "per_forms_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 1002,
        role_uuid: CREATE_FORMS_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Forms",
        element: "per_forms_create",
        dependency_to_element_list: ["per_forms_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 1003,
        role_uuid: EDIT_FORMS_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Forms",
        element: "per_forms_update",
        dependency_to_element_list: ["per_forms_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 11,
    name: "Location Group",
    priority: 11,
    note: "",
    permission: [
      {
        id: 1101,
        role_uuid: LOCATION_GROUP_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          CREATE_LOCATION_GROUP_ACCESS_KEY,
          EDIT_LOCATION_GROUP_ACCESS_KEY,
        ],
        notes: "User Can View Location Group",
        element: "per_location_group_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 1102,
        role_uuid: CREATE_LOCATION_GROUP_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Create Location Group",
        element: "per_location_group_create",
        dependency_to_element_list: ["per_location_group_view"],
        checked: false,
        disabled: false,
      },
      {
        id: 1103,
        role_uuid: EDIT_LOCATION_GROUP_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Edit Location Group",
        element: "per_location_group_update",
        dependency_to_element_list: ["per_location_group_view"],
        checked: false,
        disabled: false,
      },
    ],
  },
  {
    id: 12,
    name: "Attendance Configuration",
    priority: 12,
    note: "",
    permission: [
      {
        id: 1201,
        role_uuid: ATTENDANCE_CONFIGURATION_VIEW_ACCESS_KEY,
        dependency_for_uuid_list: [
          UPDATE_ATTENDANCE_CONFIGURATION_ACCESS_KEY,
        ],
        notes: "User Can View Attendance Configuration",
        element: "per_attendance_configuration_view",
        dependency_to_element_list: [],
        checked: false,
        disabled: false,
      },
      {
        id: 1202,
        role_uuid: UPDATE_ATTENDANCE_CONFIGURATION_ACCESS_KEY,
        dependency_for_uuid_list: [],
        notes: "User Can Update Attendance Configuration",
        element: "per_attendance_configuration_update",
        dependency_to_element_list: [
          "per_attendance_configuration_view",
        ],
        checked: false,
        disabled: false,
      },
    ],
  }
];
